import style from "@styles/pages/oraculo/oraculo.module.scss";
import { VariableSchema } from "./VariableSchema";
import { Titles } from "./variables/Titles";

export default function Filters ({
  filters = {},
  boxes = [],
  editFilters,
  audienceUsed,
  selectedAudience,
}) {
  const filter_entries = Object.entries(filters || {});

  return audienceUsed && selectedAudience ? (
    <div className={style.containerFiltersAudience}>
      <div className={style.header}>
        <div className={style.icon}>
          <i className="fas fa-users" />
        </div>
        <p className={style.audienceName}>{selectedAudience?.name}</p>
        <div className={style.actions}>
          <div className={style.edit} onClick={editFilters}>
            <i className="fal fa-pen" />
          </div>
        </div>
      </div>
      <div className={style.filters}>
        {boxes.map((b) => (
          <div className={style.filter}>
            <p className={style.name}>{Titles[b.type]}</p>
            <span className={style.qty}>
              {VariableSchema.countValidClauses(b.data)}
            </span>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className={style.containerFilters}>
      <p className={style.label}>Filtros aplicados</p>
      <div className={style.filters}>
        {boxes.map((b) => (
          <div className={style.filter}>
            <p className={style.name}>{Titles[b.type]}</p>
            <span className={style.qty}>
              {VariableSchema.countValidClauses(b.data)}
            </span>
          </div>
        ))}
        {filter_entries.map(([key, filter]) => (
          <div className={style.filter}>
            <p className={style.name}>{Titles[key]}</p>
            <span className={style.qty}>
              {filter?.length || filter?.value?.length || "--"}
            </span>
          </div>
        ))}
      </div>

      <div className={style.actions}>
        <div className={style.edit} onClick={editFilters}>
          <i className="fal fa-pen" />
        </div>
      </div>
    </div>
  );
};
